export default __webpack_public_path__ + "static/media/spindex-banner.73c3dcf6.jpg";